import { useState, useRef, useEffect, useCallback } from 'react';

// @mention — chat aur post dono me.
// Textarea/input ke oopar chhoti list; @ ke baad type karo, list se chuno.
// Backend: /api/users/mention/  (?type=followers  ?specials=1 for @everyone/@followers)
function authHeaders() {
  const tok = localStorage.getItem('token');
  return tok ? { Authorization: `Token ${tok}` } : {};
}

export default function MentionBox({
  value, onChange, placeholder, style, multiline, onEnter, allowSpecials, inputId,
}) {
  const ref = useRef(null);
  const [list, setList] = useState([]);
  const [show, setShow] = useState(false);
  const [at, setAt] = useState(-1);   // jahan @ shuru hua
  const [pick, setPick] = useState(0);

  const search = useCallback((term) => {
    const p = new URLSearchParams({ q: term });
    if (allowSpecials) p.set('specials', '1');
    fetch(`/api/users/mention/?${p}`, { headers: authHeaders() })
      .then((r) => r.json())
      .then((d) => { setList(Array.isArray(d) ? d.slice(0, 8) : []); setPick(0); })
      .catch(() => setList([]));
  }, [allowSpecials]);

  const onType = (e) => {
    const v = e.target.value;
    onChange(v);
    const caret = e.target.selectionStart;
    const upto = v.slice(0, caret);
    const m = upto.match(/@(\w*)$/);   // aakhri @word
    if (m) {
      setAt(caret - m[0].length);
      setShow(true);
      search(m[1]);
    } else {
      setShow(false);
    }
  };

  const choose = (u) => {
    const before = value.slice(0, at);
    const caret = ref.current ? ref.current.selectionStart : value.length;
    const after = value.slice(caret);
    const next = `${before}@${u.username} ${after}`;
    onChange(next);
    setShow(false);
    setTimeout(() => { if (ref.current) ref.current.focus(); }, 0);
  };

  const onKey = (e) => {
    if (show && list.length) {
      if (e.key === 'ArrowDown') { e.preventDefault(); setPick((p) => (p + 1) % list.length); return; }
      if (e.key === 'ArrowUp') { e.preventDefault(); setPick((p) => (p - 1 + list.length) % list.length); return; }
      if (e.key === 'Enter' || e.key === 'Tab') { e.preventDefault(); choose(list[pick]); return; }
      if (e.key === 'Escape') { setShow(false); return; }
    }
    if (!multiline && e.key === 'Enter' && onEnter) { onEnter(); }
  };

  const Tag = multiline ? 'textarea' : 'input';

  return (
    <div style={{ position: 'relative', flex: 1 }}>
      {show && list.length > 0 && (
        <div style={{
          position: 'absolute', bottom: '100%', left: 0, right: 0, marginBottom: 4,
          background: '#fff', border: '0.5px solid #C7C5BC', borderRadius: 10,
          boxShadow: '0 6px 24px rgba(0,0,0,.12)', maxHeight: 220, overflowY: 'auto', zIndex: 50,
        }}>
          {list.map((u, i) => (
            <div key={u.username} onMouseDown={(e) => { e.preventDefault(); choose(u); }}
              style={{
                padding: '8px 12px', cursor: 'pointer', fontSize: 14,
                display: 'flex', alignItems: 'center', gap: 8,
                background: i === pick ? '#EAF6F1' : '#fff',
              }}>
              <span style={{ fontSize: 15 }}>{u.special ? (u.username === 'everyone' ? '📢' : '👥') : '@'}</span>
              <span style={{ fontWeight: u.special ? 600 : 400, color: '#2C2C2A' }}>
                {u.display || u.username}
              </span>
              {!u.special && <span style={{ fontSize: 12, color: '#888780' }}>@{u.username}</span>}
            </div>
          ))}
        </div>
      )}
      <Tag
        id={inputId}
        ref={ref}
        style={style}
        placeholder={placeholder}
        value={value}
        onChange={onType}
        onKeyDown={onKey}
        {...(multiline ? { rows: 8 } : {})}
      />
    </div>
  );
}
